import heroBanner from "../../assets/images/pages/prep-course.png";
import permitImage from "../../assets/images/pages/first-time-driver.jpg";
import ShellCard from "../../components/ShellCard.jsx";
import { useEffect } from "react";

const PrepCourse = () => {
  useEffect(() => {
    document.title = "Florida Permit Practice Test - Metro Traffic School";
  }, []);

  return (
    <>
      <section className="hero-slider-section">
        <div
          className="hero-banner"
          style={{
            backgroundImage: `url(${heroBanner})`,
          }}
        >
          <div className="banner-text-container">
            <div className="banner-heading">
              <h1 className="banner-title">
                Take the Florida Permit Practice Test
              </h1>
              <p className="banner-subheading">for DMV Permit Exam</p>
            </div>
          </div>
        </div>
      </section>

      <section className="container py-5">
        <div className="row">
          <div className="col-12">
            <ShellCard>
              <div className="row">
                <div className="col-12">
                  <div className="mb-4">
                    <h5 className="mb-3 fw-bold" style={{ color: "var(--metro-yellow)" }}>
                      Course Description
                    </h5>
                    <p className="lh-lg" style={{ color: "#fff" }}>
                      The Florida prep course will provide you with tips to pass
                      the Permit Test by providing practice test questions that
                      will help you pass the DMV Permit Test. The practice test
                      will get you prepared for the DMV Permit Test and help you
                      increase your chances of passing the Permit Test on your
                      first attempt. You will be able to take different practice
                      exams with random questions. You will also be able to
                      review and study the correct answers after you take the
                      practice test. This course will pay for itself by reducing
                      DMV retake fees.
                    </p>
                  </div>

                  <div className="d-flex flex-column align-items-center my-3">
                    <p
                      className="mb-3 fw-bold"
                      style={{ color: "var(--metro-yellow)", fontSize: "2rem" }}
                    >
                      $19.95
                    </p>
                    <a
                      href="https://courses.metrotrafficschool.com/onlinecourses/index.php/register?awc_id=NTE1"
                      target="_blank"
                      rel="noopener noreferrer"
                      className="btn btn-lg px-4 py-3 fw-bold text-dark metro-btn-primary text-decoration-none"
                      style={{
                        backgroundColor: "var(--metro-yellow)",
                        border: "none",
                      }}
                    >
                      <i className="fas fa-user-plus me-2"></i> Register Now!
                    </a>
                  </div>
                </div>
              </div>
            </ShellCard>
          </div>
        </div>
      </section>
    </>
  );
};

export default PrepCourse;
